export default "__VITE_ASSET__GEA$6Pde__"